import api from "./api";

export async function getDriverDocuments(driverId) {
  const res = await api.get(`driver-documents/driver/${driverId}`);
  return res.data.data;
}

export async function uploadDriverDocument(payload) {
  const res = await api.post("driver-documents", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data.data;
}

